import { logError } from 'fergy-core-react-logging';
import { type FunctionComponent, useContext } from 'react';
import { ERROR_ADD_FINISH_SAMPLE, SUCCESS_ADD_FINISH_SAMPLE } from '../../../constants/product';
import { ProductFamilyContext } from '../../../contexts/product-family/product-family.context';
import { useAddToCartAction } from '../../../hooks/add-to-cart/add-to-cart.hooks';
import { useNotification } from '../../../hooks/notification/notification.hooks';
import { StyledButton } from '../../buttons';

export type AddSampleToCartButtonProps = {
	sampleId: number;
	pageName: string;
};

export const AddSampleToCartButton: FunctionComponent<AddSampleToCartButtonProps> = ({ sampleId, pageName }) => {
	// bring back the sampleId and pass that to the hook.
	const { notifyDanger, notifySuccess } = useNotification();
	const { productFamily } = useContext(ProductFamilyContext);
	const { addToCart, status } = useAddToCartAction();
	// We add 1 product sample at a time
	const quantityToAdd = 1;
	const addToCartAction = () => {
		const analyticsData = {
			variantId: sampleId,
			pageName,
			link: 'Get a Sample',
			linkName: 'Get a Sample',
			productFamily
		};
		addToCart({ variantId: sampleId, quantity: quantityToAdd, pricedOptions: [], analyticsData })
			.then(() => notifySuccess(SUCCESS_ADD_FINISH_SAMPLE))
			.catch(() => {
				notifyDanger(ERROR_ADD_FINISH_SAMPLE);
				logError('Add to cart failed unexpectedly');
			});
	};

	return (
		<StyledButton disabled={status.loading} onClick={addToCartAction} automationHook={'get-a-sample'} buttonStyle="SECONDARY">
			<span className="nowrap">Get a Sample</span>
		</StyledButton>
	);
};
